"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

var boxShadowMixin = function boxShadowMixin(_ref) {
  var selectors = _ref.selectors;
  return "box-shadow: 0 0 10px 0 ".concat((0, _utils.opacify)(selectors.color('accent1'), 0.2), ";");
};

var _default = boxShadowMixin;
exports.default = _default;